import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { apiService } from "@/services/api";

export const GenreEdit: React.FC = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const data = await apiService.getGenres();
        const genre = (data as any[]).find(
          (g: any) => String(g.id) === String(id)
        );
        if (genre) {
          form.setFieldsValue({ name: genre.name });
        }
      } catch (e) {
        message.error("Impossible de charger le genre");
      }
    })();
  }, [id]);

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await apiService.updateGenre(Number(id), { name: values.name });
      message.success("Genre mis à jour");
      navigate("/categories");
    } catch (e: any) {
      message.error("Erreur lors de la mise à jour");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title={`Modifier le genre #${id}`}>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item label="Nom" name="name" rules={[{ required: true }]}>
          <Input placeholder="Nom du genre" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Enregistrer
        </Button>
      </Form>
    </Card>
  );
};

export default GenreEdit;
